import React from "react";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import { styled } from "@mui/material/styles";

const ColorButton = styled(Button)(({ theme }) => ({
  backgroundColor: "#23b248",
  color: "white",
  transition: "0.4s",
  borderRadius: "100px",
  fontWeight: "500",
  padding: "10px 20px 5px 20px",
  "&:hover": {
    backgroundColor: "#92D297",
  },
}));

const CanceledColorButton = styled(Button)(({ theme }) => ({
  backgroundColor: "#ff4a6b",

  transition: "0.4s",
  borderRadius: "100px",
  fontWeight: "500",
  padding: "10px 20px 5px 20px",
  "&:hover": {
    backgroundColor: "#ff4a6b99",
    color: "white",
  },
}));

function CustomButton({ OnClickFunc, Icon, txt, disabled, type, btnRef }) {
  return (
    <Stack direction="row" spacing={2}>
      {txt && txt.toLowerCase() === "cancel" ? (
        <CanceledColorButton
          variant="contained"
          type={type}
          disabled={disabled}
          endIcon={Icon && <Icon />}
          onClick={OnClickFunc}
          ref={btnRef && btnRef}
        >
          {txt + " "}
        </CanceledColorButton>
      ) : (
        <ColorButton
          variant="contained"
          type={type}
          disabled={disabled}
          endIcon={Icon && <Icon />}
          onClick={OnClickFunc}
          ref={btnRef && btnRef}
        >
          {txt + " "}
        </ColorButton>
      )}
    </Stack>
  );
}

export default CustomButton;
